/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import AppConst from '../constants/app.constant';

const testdataService = () => {
  const content = {};
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function setRandomValues(data) {
    const cloudArray = ['CL', 'FW', 'SC', 'BK', 'OV'];
    _forEach(data.forecast, (forecast) => {
      // Go Random Temperature
      forecast.tmp = getRandomInt(-40, 120);
      forecast.rlh = getRandomInt(0, 100);
      // Go Random Wind
      forecast.wsp = getRandomInt(0, 70); // ToDo Increase domain to max = 120
      forecast.xwd = getRandomInt(0, 70); // ToDo Increase domain to max = 120
      forecast.wdr = getRandomInt(0, 36);
      forecast.wgs = getRandomInt(0, 70);

      // Go Random Ceiling
      forecast.vis = getRandomInt(1, 7).toFixed(0);
      forecast.cig = getRandomInt(1, 8).toFixed(0);

      // Go Random Precepitation
      forecast.p06 = getRandomInt(0, 100);
      forecast.t06 = getRandomInt(0, 100);
      forecast.t01 = getRandomInt(0, 100);
      forecast.st6 = getRandomInt(0, 100);
      forecast.q06 = getRandomInt(0, 6);
      forecast.ppo = getRandomInt(0, 100);
      forecast.cp2 = getRandomInt(0, 100);
      forecast.pos = getRandomInt(0, 100);
      forecast.poz = getRandomInt(0, 100);
      forecast.sno = getRandomInt(0, 100);
      forecast.fzp = getRandomInt(0, 100);

      // Cloud Strip cld
      forecast.cld = cloudArray[Math.floor(Math.random() * cloudArray.length)];
    });
  }
  content.goRandomBounds = (data, dataMode) => {
    // Giving Bounds to TEST DATA
    switch (dataMode) {
      case AppConst.dataMode.meteogram:
        setRandomValues(data);
        break;
      case AppConst.dataMode.routeprofile:
      case AppConst.dataMode.gridview:
        _forEach(data, (airport) => {
          setRandomValues(airport);
        });
        break;
      default:
    }
    return data;
  };
  return content;
};
export default testdataService();
